"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const newBox_1 = __importDefault(require("../../components/box/newBox"));
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const HomeApplication = () => {
    const navigation = (0, useAppNavigation_1.default)();
    return (react_1.default.createElement(newBox_1.default, { title: "Business Loans", btn: true, textArea: "Loans without collateral", butonText: "Get a Loan", action: () => navigation.navigate(screenConstants_1.NEW_LOAN_APPLICATION_SCREEN), eventName: "home_applyForLoan", display: true }));
};
exports.default = HomeApplication;
